import { Link } from "react-router-dom";
import { isMapsUrl } from "../DirectionsActions";
import { InlineMapLink } from "../InlineMapLink";
import { MomentButton } from "../../radio/MomentLink";

const INLINE = /(\*\*[^*]+\*\*|\*[^*]+\*|\[[^\]]+\]\([^)\s]+\)(?:\{(?:#[0-9a-fA-F]{3,6}|new)\})?)/g;
const isExt = (u) => /^https?:/i.test(u || "");

// Same mini-markdown as StoryChapterBlock.renderInline, but <strong> inherits the surrounding color (safe on dark sections).
export const renderInline = (text, accent = "#2E5C55") =>
  (text || "").split(INLINE).map((part, i) => {
    if (!part) return null;
    if (part.startsWith("**")) return <strong key={i} className="font-extrabold">{part.slice(2, -2)}</strong>;
    if (part.startsWith("*")) return <em key={i}>{part.slice(1, -1)}</em>;
    const m = part.match(/^\[([^\]]+)\]\(([^)\s]+)\)(?:\{(#[0-9a-fA-F]{3,6}|new)\})?$/);
    if (m) {
      const cls = "underline decoration-2 underline-offset-2 font-bold hover:opacity-80";
      const color = m[3] && m[3] !== "new" ? m[3] : accent;
      if (m[3] === "new") return <a key={i} href={m[2]} target="_blank" rel="noopener noreferrer" className={cls} style={{ color }}>{m[1]}</a>;
      if (m[2].startsWith("moment:")) return <MomentButton key={i} momentKey={m[2].slice(7)} label={m[1]} className="mx-1 align-middle" />;
      if (isMapsUrl(m[2])) return <InlineMapLink key={i} href={m[2]} label={m[1]} className={cls} style={{ color }} />;
      if (m[2].startsWith("#") || isExt(m[2])) return <a key={i} href={m[2]} target={isExt(m[2]) ? "_blank" : undefined} rel="noopener noreferrer" className={cls} style={{ color }}>{m[1]}</a>;
      return <Link key={i} to={m[2]} className={cls} style={{ color }}>{m[1]}</Link>;
    }
    return part;
  });
